import React from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { IconEdit, IconTrash, IconZoomIn, IconEye } from '@tabler/icons-react';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";

const DatatableRiskHeatmap = (props) => {
  // console.log(props);
  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: 'Aksi',
      minWidth: '100px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <button
            style={{ textAlign: 'center', width: '100%' }}
            className="btn btn-sm btn-outline-success"
            type="button"
            title="Detil Info Kegiatan & Sasaran"
            onClick={() =>
              handleChangePage(`/risk-register/${row.idActivityTarget}`)
            }
          >
            <IconZoomIn stroke={2} />
          </button>
        </>
      ),
    },
    {
      name: 'Nama Kegiatan',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
          {row?.risk_activity_target?.name}
        </div>
      ),
      style: {
        // You can also add more styles here
        whiteSpace: 'normal',
      },
    },
    {
      name: 'Kode Risiko',
      minWidth: '100px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <div style={{ textAlign: 'center', width: '100%' }}>
          {'R.'}
          {row.codeRisk}
        </div>
      ),
      style: {
        // You can also add more styles here
        whiteSpace: 'normal',
      },
    },
    {
      name: 'Dampak',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <div style={{ textAlign: 'center', width: '100%' }}>
          {row.impactAnalysis === '1' ? (
            <span className="badge badge-primary text-black">1</span>
          ) : row.impactAnalysis === '2' ? (
            <span className="badge badge-success text-black">2</span>
          ) : row.impactAnalysis === '3' ? (
            <span
              className="badge text-black"
              style={{ backgroundColor: 'yellow' }}
            >
              3
            </span>
          ) : row.impactAnalysis === '4' ? (
            <span
              className="badge text-black"
              style={{ backgroundColor: 'orange' }}
            >
              4
            </span>
          ) : row.impactAnalysis === '5' ? (
            <span className="badge badge-danger text-black">5</span>
          ) : (
            ''
          )}
        </div>
      ),
      style: {
        // You can also add more styles here
        whiteSpace: 'normal',
      },
    },
    {
      name: 'Probabilitas',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={{ textAlign: 'center', width: '100%' }}>
            {row.probabilityAnalysis === '1' ? (
              <span className="badge badge-primary text-black">1</span>
            ) : row.probabilityAnalysis === '2' ? (
              <span className="badge badge-success text-black">2</span>
            ) : row.probabilityAnalysis === '3' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'yellow' }}
              >
                3
              </span>
            ) : row.probabilityAnalysis === '4' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'orange' }}
              >
                4
              </span>
            ) : row.probabilityAnalysis === '5' ? (
              <span className="badge badge-danger text-black">5</span>
            ) : (
              ''
            )}
          </div>
        </>
      ),
    },
    ...(props.role === 'Administrator'
      ? [
        {
          name: 'Unit Kerja',
          minWidth: '150px',
          cell: (row) => (
            <div style={{ textAlign: 'center', width: '100%' }}>
              {row?.risk_activity_target?.user?.risk_division?.namaDivision}
            </div>
          ),
          style: {
            whiteSpace: 'normal',
          },
        },
      ]
      : []),
  ];

  const customStyles = {
    rows: {
      style: {
        borderBottom: '1px solid #ddd', // Garis bawah pada setiap baris
      },
    },
    headCells: {
      style: {
        borderBottom: '2px solid #ccc', // Garis bawah yang lebih tebal pada header
        backgroundColor: '#0d6efd', // Warna latar belakang header
        fontWeight: 'bold', // Membuat teks header lebih tegas
        textAlign: 'center', // Rata tengah teks
        justifyContent: 'center', // Pusatkan konten secara horizontal
        color: '#FFFF',
      },
    },
    cells: {
      style: {
        borderRight: '1px solid #ddd', // Garis pemisah antar kolom
        padding: '10px', // Padding agar lebih rapi
      },
    },
  };

  return (
    <>
      <div style={{ overflowX: 'auto', maxWidth: '1200px' }}>
        <h2 className="text-xl mb-4 text-primary">Daftar Risiko Peta Panas</h2>
        <hr className="my-3" />
        <DataTable
          columns={columns}
          data={props?.listRiskHeatmap}
          customStyles={customStyles}
          pagination
          fixedHeader
          highlightOnHover
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Cari Risiko"
              className="w-50 form-control m-3"
              values={props.search}
              onChange={(e) => {
                // Hanya izinkan huruf, angka, dan spasi
                const cleanValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                props.handleChangeSearch(cleanValue);
              }}
            />
          }
          subHeaderAlign="center"
        />
      </div>
    </>
  );
};

export default DatatableRiskHeatmap;
